module.exports = __webpack_public_path__ + "files/e6ff1ac2b214236d0c78dedd05e313d8.png";